module.exports = __webpack_public_path__ + "static/media/cooperative-partnerA.7eac66f7.png";